import { render } from "./MyFollowerPage.vue?vue&type=template&id=014ab872&scoped=true"
import script from "./MyFollowerPage.vue?vue&type=script&lang=js"
export * from "./MyFollowerPage.vue?vue&type=script&lang=js"

import "./MyFollowerPage.vue?vue&type=style&index=0&id=014ab872&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014ab872"]])

export default __exports__